import React, { useState, useEffect } from "react";
import Menu from "../Menu";
import { Link } from "react-router-dom";
import Header from "../Header";
import DataTable from "react-data-table-component";
import { http } from "../../services/http";
import { Alert, InputAdornment, Grid as MIUGrid, Snackbar, Tooltip} from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { green, red } from '@mui/material/colors';
import CookieService from "../../services/CookieService";
const ENTER_KEY = 13;
let user = CookieService.get("user");
const emailAdmin = process.env.REACT_APP_EMAIL_ADMIN;

export default function UserTable() {
  const [users, setUsers] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [inputText, setInputText] = useState("");
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalItens, setTotalItens] = useState(10);
  const [inactive, setInactive] = useState(false);
  const [userAccess, setUserAccess] = useState([]);

  const userCanEdit = () => {
    if (user?.email === emailAdmin)
      return true
    const access = userAccess.find(access => access.name === 'Admin' && access.checked && access.allow_edit);
    return access ? access.allow_edit : false;
  };
  
  function searchUsers(page, search) {
    var paging = `&page=${page}&limit=10`;
    http.get("users?search=" + search + paging).then(
      (response) => {
        setUsers(response?.data?.data);
        setTotalItens(parseInt(response?.data?.total));
        setPageIndex(page);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  useEffect(() => {
    searchUsers(1, inputText);
  }, []);

  const [timer, setTimer] = useState(null);

  function triggerChange() {
    if (inputText.length > 2 || inputText.length == 0) {
      setSearchText(inputText);
      searchUsers(1, inputText);
    }
  }

  function handleKeyUp(e) {
    if (e.keyCode === ENTER_KEY) {
      clearTimeout(timer);
      triggerChange();
    }

    clearTimeout(timer);

    setTimer(
      setTimeout(function () {
        triggerChange();
      }, 400)
    );
  }

  function handleSearchText(e) {
    setInputText(e.target.value);
  }

  function handlePage(page, totalRows) {
    setPageIndex(page);
    searchUsers(page, inputText);
  }

  function handleInactive(e) {
    setPageIndex(1);
    setInactive(e.target.checked);
  }

  function handleChangeRowsPerPage(perPage) {
    setPageSize(perPage);
    searchUsers(1, inputText);
  }

  useEffect(() => {
    //Set User
    if (user && user.user_access) {
      setUserAccess(user.user_access);
    }
  }, []); //[user]);

  return (
    <div id="wrapper">
      <Menu />
      <div id="page-wrapper" className="gray-bg">
        <Header />
        <div className="row wrapper border-bottom white-bg page-heading">
          <div className="col-lg-10">
            <h2><i className="fa fa-user"></i>  Usuários</h2>
            {/* <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a>Home</a>
              </li>
            </ol> */}
          </div>
          <div className="col-lg-2" style={{ textAlign: "right", alignSelf: "flex-end" }}>
            <Link to="/new-user">
              <button 
                type="button"
                style={{marginRight: '5px'}}
                className="btn btn-primary" 
                disabled={!userCanEdit()}
                >
              Adicionar  <i className="fa fa-plus"></i>
              </button>
            </Link>
          </div>
        </div>
        <div className="wrapper wrapper-content animated fadeInRight">
          <div className="row">
            <div className="col-lg-12">
              <div className="ibox">
                <div className="ibox-title" style={{paddingRight: 15}}>
                  <div className="form-group row">
                    <div className="col-lg-12">
                      <input 
                        style={{width: '100%'}}
                        value={inputText} 
                        placeholder="Buscar" 
                        onChange={handleSearchText} 
                        onKeyUp={handleKeyUp} 
                        type="text" 
                        className="form-control" 
                        />
                    </div>
                    {/* <div className="col-sm-2" style={{ textAlign: "right", alignSelf: "flex-end" }}>
                      <input type="checkbox" value={inactive} onChange={handleInactive} defaultChecked={inactive} /> <label>Buscar Inativos</label>
                    </div> */}
                  </div>
                </div>
                <div className="ibox-content">
                  <DataTable
                    data={users?.map(({ name, id, email, active }) => ({
                      id,
                      name,
                      email,
                      active,
                      active: active != null ? active.toString() : "false",
                    }))}
                    pagination={true}
                    paginationServer={true}
                    paginationTotalRows={totalItens}
                    paginationPerPage={pageSize}
                    paginationDefaultPage={pageIndex}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    onChangePage={handlePage}
                    columns={[
                      {
                        name: "Nome",
                        minWidth: "150px",
                        cell: (row) => (
                          userCanEdit() ? (
                            <div>
                              <Link to={{ pathname: "/user-details", user_id: row.id  }}>
                                <span>{row.name}</span>
                              </Link>
                            </div>
                          ) : (
                            <div>
                              <span>{row.name}</span>
                            </div>
                          )
                        ),
                      },
                      
                      {
                        name: "Email",
                        selector: "email",
                        minWidth: "230px",
                        wrap: true,
                        // cell: row => <div data-tag="allowRowEvents">{row.email}</div>
                      },
                      {
                        name: "Status",
                        selector: (row) => 
                          row.active === 'true' ? (
                            <Tooltip title="Ativo">
                              <CheckCircleIcon style={{ color: green[500] }} />
                            </Tooltip>
                          ) : (
                            <Tooltip title="Inativo">
                              <CancelIcon style={{ color: red[500] }} />
                            </Tooltip>
                          ),
                        compact: true,
                        grow: true,
                      },
                      
                      {
                        name: "Ação",
                        compact: true,
                        cell: (row) => (
                          <Link to={{ pathname: "/edit-user", user_id: row.id }}>
                            <button disabled={!userCanEdit()} type="button" className="btn btn-primary btn-sm">
                              Editar
                            </button>
                          </Link>
                        ),
                        grow: true,
                      },
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
